export const ETICKET_REDEEM_REQUEST = 'ETICKET_REDEEM_REQUEST'
export const ETICKET_REDEEM_SUCCESS = 'ETICKET_REDEEM_SUCCESS'
export const ETICKET_REDEEM_FALIURE = 'ETICKET_REDEEM_FALIURE'
export const ETICKET_BALANCE_REQUEST = 'ETICKET_BALANCE_REQUEST'
export const ETICKET_BALANCE_SUCCESS = 'ETICKET_BALANCE_SUCCESS'
export const ETICKET_BALANCE_FALIURE = 'ETICKET_BALANCE_FALIURE'
